// // components/SkeletonComponents/UserListSkeleton.jsx
// import React from 'react';

// const Skeleton = ({ className = '', variant = 'stream', color = 'default' }) => {
//   const baseClasses = `relative overflow-hidden rounded-md ${className}`;
  
//   const getColorClasses = () => {
//     const colors = {
//       default: 'bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200',
//       primary: 'bg-gradient-to-r from-red-100 via-pink-100 to-red-100',
//       secondary: 'bg-gradient-to-r from-blue-100 via-indigo-100 to-blue-100',
//       success: 'bg-gradient-to-r from-green-100 via-emerald-100 to-green-100',
//       warning: 'bg-gradient-to-r from-yellow-100 via-amber-100 to-yellow-100',
//       info: 'bg-gradient-to-r from-cyan-100 via-teal-100 to-cyan-100',
//       purple: 'bg-gradient-to-r from-purple-100 via-violet-100 to-purple-100',
//       rainbow: 'bg-gradient-to-r from-red-100 via-yellow-100 via-green-100 via-blue-100 via-purple-100 to-red-100'
//     };
//     return colors[color] || colors.default;
//   };
  
//   const getVariantClasses = () => {
//     switch (variant) {
//       case 'stream':
//         return `${getColorClasses()} before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1.5s_ease-in-out_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/70 before:to-transparent`;
//       case 'pulse':
//         return `${getColorClasses()} animate-[pulse_2s_cubic-bezier(0.4,0,0.6,1)_infinite]`;
//       case 'wave':
//         return `${getColorClasses()} bg-[size:200%_100%] animate-[wave_3s_linear_infinite]`;
//       case 'glow':
//         return `${getColorClasses()} animate-[glow_2s_ease-in-out_infinite]`;
//       default:
//         return `${getColorClasses()} animate-pulse`;
//     }
//   };

//   return <div className={`${baseClasses} ${getVariantClasses()}`} />;
// };

// export const UserListSkeleton = () => (
//   <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
//     <div className="max-w-7xl mx-auto space-y-6">
//       {/* Header Skeleton */}
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 animate-[fadeIn_0.3s_ease-out]">
//         <div className="flex items-center gap-4">
//           <Skeleton className="h-10 w-10 rounded-lg" color="primary" variant="pulse" />
//           <div className="space-y-2">
//             <Skeleton className="h-8 w-48" color="default" variant="stream" />
//             <Skeleton className="h-5 w-64" color="default" variant="wave" />
//           </div>
//         </div>
//         <Skeleton className="h-10 w-36 rounded-lg shadow-lg" color="primary" variant="glow" />
//       </div>

//       {/* Search and Filters Skeleton */}
//       <div className="space-y-4 animate-[fadeIn_0.4s_ease-out]">
//         <div className="flex flex-col sm:flex-row gap-4">
//           <div className="relative flex-1">
//             <Skeleton className="h-11 w-full rounded-lg shadow-sm" color="default" variant="stream" />
//           </div>
//           <Skeleton className="h-11 w-32 rounded-lg shadow-sm" color="secondary" variant="pulse" />
//         </div>
//       </div>

//       {/* Table Skeleton */}
//       <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
//         {/* Table Header */}
//         <div className="bg-gradient-to-r from-red-50 via-pink-50 to-red-50 p-4 border-b animate-[fadeIn_0.5s_ease-out]">
//           <div className="grid grid-cols-9 gap-4">
//             <Skeleton className="h-4 w-20" color="primary" variant="pulse" />
//             <Skeleton className="h-4 w-24" color="primary" variant="pulse" />
//             <Skeleton className="h-4 w-28" color="primary" variant="pulse" />
//             <Skeleton className="h-4 w-24" color="primary" variant="pulse" />
//             <Skeleton className="h-4 w-16" color="primary" variant="pulse" />
//             <Skeleton className="h-4 w-20" color="primary" variant="pulse" />
//             <Skeleton className="h-4 w-28" color="primary" variant="pulse" />
//             <Skeleton className="h-4 w-32" color="primary" variant="pulse" />
//             <Skeleton className="h-4 w-20" color="primary" variant="pulse" />
//           </div>
//         </div>
        
//         {/* Table Rows */}
//         {[...Array(8)].map((_, i) => (
//           <div
//             key={i}
//             className="p-4 border-b border-gray-50 hover:bg-gradient-to-r hover:from-transparent hover:to-gray-50/50 transition-all duration-300 opacity-0 animate-[slideIn_0.5s_ease-out_forwards]"
//             style={{ animationDelay: `${(i + 1) * 0.1}s` }}
//           >
//             <div className="grid grid-cols-9 gap-4 items-center">
//               {/* User Cell */}
//               <div className="flex items-center space-x-3">
//                 <Skeleton 
//                   className="w-10 h-10 rounded-full shadow-sm" 
//                   color={['rainbow', 'purple', 'success', 'info', 'warning'][i % 5]}
//                   variant="glow" 
//                 />
//                 <div className="space-y-1">
//                   <Skeleton className="h-4 w-24" variant="stream" />
//                   <Skeleton className="h-3 w-20 opacity-70" variant="pulse" />
//                 </div>
//               </div>
              
//               {/* Contact Cell */}
//               <div className="space-y-1">
//                 <Skeleton className="h-4 w-32" color="info" variant="stream" />
//                 <Skeleton className="h-3 w-24 opacity-70" variant="wave" />
//               </div>
              
//               {/* Department Cell */}
//               <Skeleton className="h-4 w-28" color="secondary" variant="stream" />
              
//               {/* Division Cell */}
//               <Skeleton className="h-4 w-24" color="purple" variant="stream" />
              
//               {/* Role Badge */}
//               <Skeleton className="h-6 w-20 rounded-full" color={['primary', 'secondary', 'success'][i % 3]} variant="pulse" />
              
//               {/* Status Badge */}
//               <Skeleton className="h-6 w-16 rounded-full" color={i % 2 === 0 ? 'success' : 'warning'} variant="glow" />
              
//               {/* Date */}
//               <Skeleton className="h-4 w-24" variant="wave" />
              
//               {/* Created/Updated */}
//               <div className="space-y-1">
//                 <Skeleton className="h-3 w-28" variant="stream" />
//                 <Skeleton className="h-3 w-24 opacity-70" variant="pulse" />
//               </div>
              
//               {/* Actions */}
//               <div className="flex justify-center">
//                 <Skeleton className="h-8 w-8 rounded-lg" color="default" variant="pulse" />
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Pagination Skeleton */}
//       <div className="flex flex-col sm:flex-row justify-between items-center gap-4 animate-[fadeIn_1s_ease-out]">
//         <Skeleton className="h-5 w-48" variant="stream" />
//         <div className="flex gap-2">
//           {[...Array(5)].map((_, i) => (
//             <Skeleton 
//               key={i} 
//               className="h-10 w-10 rounded-lg shadow-sm" 
//               color={i === 2 ? 'primary' : 'default'}
//               variant={i === 2 ? 'glow' : 'pulse'} 
//             />
//           ))}
//         </div>
//       </div>
//     </div>
//   </div>
// );

// // Add animation styles
// if (typeof document !== 'undefined' && !document.getElementById('user-skeleton-styles')) {
//   const style = document.createElement('style');
//   style.id = 'user-skeleton-styles';
//   style.textContent = `
//     @keyframes shimmer {
//       to { transform: translateX(100%); }
//     }
//     @keyframes wave {
//       0%, 100% { background-position: 0% 50%; }
//       50% { background-position: 100% 50%; }
//     }
//     @keyframes fadeIn {
//       from { 
//         opacity: 0;
//         transform: scale(0.95);
//       }
//       to { 
//         opacity: 1;
//         transform: scale(1);
//       }
//     }
//     @keyframes slideIn {
//       from {
//         opacity: 0;
//         transform: translateY(20px);
//       }
//       to {
//         opacity: 1;
//         transform: translateY(0);
//       }
//     }
//     @keyframes glow {
//       0%, 100% {
//         opacity: 1;
//         box-shadow: 0 0 5px rgba(239, 68, 68, 0.1);
//       }
//       50% {
//         opacity: 0.8;
//         box-shadow: 0 0 20px rgba(239, 68, 68, 0.3), 0 0 40px rgba(239, 68, 68, 0.1);
//       }
//     }
//     @keyframes pulse {
//       0%, 100% {
//         opacity: 1;
//       }
//       50% {
//         opacity: 0.7;
//       }
//     }
//   `;
//   document.head.appendChild(style);
// }

// export default UserListSkeleton;


// components/SkeletonComponents/UserListSkeleton.jsx
import React from 'react';

export const UserListSkeleton = () => (
  <div className=" px-4 ">
    {/* Animated Background */}
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-yellow-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
      <div className="absolute top-40 left-1/2 w-80 h-80 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
    </div>

    <div className="relative">
      {/* Header Skeleton */}
      <div className="mb-6 animate-fadeInUp">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div className="flex items-center gap-4">
            {/* Back Button */}
            <div className="w-10 h-10 bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg animate-pulse"></div>
            
            <div className="flex items-center gap-3">
              {/* Icon */}
              <div className="relative">
                <div className="w-12 h-12 bg-gradient-to-br from-red-400 to-pink-400 rounded-xl animate-pulse"></div>
                <div className="absolute inset-0 bg-gradient-to-br from-red-400 to-pink-400 rounded-xl animate-ping opacity-30"></div>
              </div>
              
              <div className="space-y-2">
                {/* Title */}
                <div className="h-8 w-48 bg-gradient-to-r from-slate-300 via-slate-200 to-slate-300 rounded-lg animate-shimmer"></div>
                {/* Subtitle */}
                <div className="h-5 w-64 bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200 rounded-md animate-shimmer animation-delay-200"></div>
              </div>
            </div>
          </div>
          
          {/* Add Button */}
          <div className="relative">
            <div className="h-10 w-32 bg-gradient-to-r from-red-400 to-pink-400 rounded-lg animate-pulse shadow-lg"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-red-400 to-pink-400 rounded-lg blur-md opacity-50 animate-pulse"></div>
          </div>
        </div>
      </div>

      {/* Search and Filter Bar */}
      <div className="mb-6 space-y-4 animate-fadeInUp animation-delay-200">
        <div className="flex flex-col sm:flex-row gap-4">
          {/* Search Bar */}
          <div className="relative flex-1">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 bg-gray-300 rounded-full animate-pulse"></div>
            <div className="w-full h-11 bg-white rounded-lg shadow-sm border border-gray-200 pl-10 overflow-hidden">
              <div className="h-full w-full bg-gradient-to-r from-transparent via-gray-100 to-transparent animate-shimmer"></div>
            </div>
          </div>
          
          {/* Filter Button */}
          <div className="relative">
            <div className="h-11 w-32 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div className="h-full w-full bg-gradient-to-r from-blue-50 via-blue-100 to-blue-50 animate-shimmer"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Skeleton */}
      <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
        {/* Table Header */}
        <div className="bg-gradient-to-r from-red-50 via-pink-50 to-red-50 p-4 border-b animate-pulse">
          <div className="grid grid-cols-9 gap-4">
            {['User', 'Contact', 'Department', 'Division', 'Role', 'Status', 'Joining', 'Created', 'Actions'].map((_, idx) => (
              <div key={idx} className="h-4 bg-gradient-to-r from-red-200 via-pink-100 to-red-200 rounded animate-shimmer" 
                style={{ animationDelay: `${idx * 100}ms` }}></div>
            ))}
          </div>
        </div>
        
        {/* Table Rows */}
        {[...Array(8)].map((_, rowIdx) => (
          <div
            key={rowIdx}
            className="p-4 border-b border-gray-50 hover:bg-gray-50/50 transition-all duration-300 animate-fadeInUp"
            style={{ animationDelay: `${(rowIdx + 3) * 100}ms` }}
          >
            <div className="grid grid-cols-9 gap-4 items-center">
              {/* User Cell */}
              <div className="flex items-center space-x-3">
                <div className="relative">
                  <div className={`w-10 h-10 rounded-full animate-pulse bg-gradient-to-br ${
                    ['from-purple-400 to-pink-400', 'from-blue-400 to-cyan-400', 'from-green-400 to-teal-400', 
                     'from-yellow-400 to-orange-400', 'from-red-400 to-rose-400', 'from-indigo-400 to-purple-400'][rowIdx % 6]
                  }`}></div>
                  <div className="absolute inset-0 rounded-full animate-ping opacity-30 bg-white"></div>
                </div>
                <div className="space-y-1">
                  <div className="h-4 w-24 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 rounded animate-shimmer"></div>
                  <div className="h-3 w-16 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded animate-shimmer animation-delay-200"></div>
                </div>
              </div>
              
              {/* Contact Cell */}
              <div className="space-y-1">
                <div className="h-4 w-32 bg-gradient-to-r from-blue-100 via-blue-50 to-blue-100 rounded animate-shimmer"></div>
                <div className="h-3 w-24 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded animate-shimmer animation-delay-300"></div>
              </div>
              
              {/* Department Cell */}
              <div className="h-4 w-28 bg-gradient-to-r from-purple-100 via-purple-50 to-purple-100 rounded animate-shimmer"></div>
              
              {/* Division Cell */}
              <div className="h-4 w-24 bg-gradient-to-r from-indigo-100 via-indigo-50 to-indigo-100 rounded animate-shimmer animation-delay-200"></div>
              
              {/* Role Badge */}
              <div className={`h-6 w-20 rounded-full animate-pulse shadow-sm bg-gradient-to-r ${
                ['from-purple-200 to-purple-300', 'from-red-200 to-red-300', 'from-blue-200 to-blue-300'][rowIdx % 3]
              }`}></div>
              
              {/* Status Badge */}
              <div className="relative">
                <div className={`h-6 w-16 rounded-full shadow-sm bg-gradient-to-r ${
                  rowIdx % 2 === 0 ? 'from-green-200 to-green-300' : 'from-yellow-200 to-yellow-300'
                }`} />
                <div className={`absolute left-2 top-1/2 -translate-y-1/2 w-2 h-2 rounded-full animate-pulse ${
                  rowIdx % 2 === 0 ? 'bg-green-400' : 'bg-yellow-400'
                }`} />
              </div>
              
              {/* Date */}
              <div className="h-4 w-24 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded animate-shimmer"></div>
              
              {/* Created/Updated */}
              <div className="space-y-1">
                <div className="h-3 w-28 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded animate-shimmer"></div>
                <div className="h-3 w-24 bg-gradient-to-r from-gray-100 via-gray-50 to-gray-100 rounded animate-shimmer animation-delay-400"></div>
              </div>
              
              {/* Actions */}
              <div className="flex justify-center">
                <div className="w-8 h-8 bg-gradient-to-r from-gray-200 to-gray-300 rounded-lg animate-pulse"></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination Skeleton */}
      <div className="mt-6 flex flex-col sm:flex-row justify-between items-center gap-4 animate-fadeInUp animation-delay-1000">
        <div className="h-5 w-48 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 rounded animate-shimmer"></div>
        <div className="flex gap-2">
          {[...Array(5)].map((_, idx) => (
            <div
              key={idx}
              className={`relative w-10 h-10 rounded-lg shadow-sm overflow-hidden ${
                idx === 2 ? 'bg-gradient-to-r from-red-300 to-pink-300' : 'bg-gradient-to-r from-gray-200 to-gray-300'
              }`}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent animate-shimmer"
                style={{ animationDelay: `${idx * 200}ms` }}></div>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* CSS Animations */}
    <style >{`
      @keyframes shimmer {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
      }
      
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      @keyframes blob {
        0%, 100% { transform: translate(0px, 0px) scale(1); }
        33% { transform: translate(30px, -50px) scale(1.1); }
        66% { transform: translate(-20px, 20px) scale(0.9); }
      }
      
      .animate-shimmer {
        animation: shimmer 2s linear infinite;
      }
      
      .animate-fadeInUp {
        animation: fadeInUp 0.8s ease-out forwards;
        opacity: 0;
      }
      
      .animate-blob {
        animation: blob 7s infinite;
      }
      
      .animation-delay-200 { animation-delay: 200ms; }
      .animation-delay-300 { animation-delay: 300ms; }
      .animation-delay-400 { animation-delay: 400ms; }
      .animation-delay-1000 { animation-delay: 1000ms; }
      .animation-delay-2000 { animation-delay: 2s; }
      .animation-delay-4000 { animation-delay: 4s; }
    `}</style>
  </div>
);

export default UserListSkeleton;
